import { addWeeks } from "date-fns"
import i18n from "../../i18n"

const PLAN_LENGTH_WEEKS = 4

export function formatShortDate(date: Date): string {
  return new Intl.DateTimeFormat(i18n.language, {
    day: "numeric",
    month: "short",
  }).format(date)
}

export default function getTargetDateLabel(): string {
  return formatShortDate(addWeeks(new Date(), PLAN_LENGTH_WEEKS))
}
